import React from 'react';
import { Datagrid, ReferenceManyField, TextField } from 'react-admin';
import { Link } from 'react-router-dom';

type LinkFieldProps = {
  record: any
};

const LinkField = (props: LinkFieldProps) => (
  <Link to={`/${props.record.type}/${props.record.id}`}>
    {props.record.name}
  </Link>
);

type Props = {
  basePath: string,
  record: any,
  resource: string
};

const ReferenceTab = (props: Props) => (
  <span>
    <div style={{ padding: 10 }}>
      References search against:<br />
      <div style={{ paddingLeft: 10 }}>
        Ad tag campaigns -> creative.content<br />
        Site campaigns -> html_head, pixels.content<br />
        Creative templates -> template_body<br />
        JS function -> jscode<br />
        Placement -> ad_units.pre_adunit_rendered_custom<br />
        Server file -> content
      </div>
    </div>

    <ReferenceManyField label="References" target="macro_map_id" resource={props.resource} basePath={props.basePath} reference="helpers/macro_map_references" sort={{ field: 'name', order: 'ASC' }} record={props.record} allowEmpty>
      <Datagrid>
        <TextField source="label" sortable={false} />
        <LinkField record={props.record} />
        <TextField source="type" />
      </Datagrid>
    </ReferenceManyField>
  </span>
);

export default ReferenceTab;



// WEBPACK FOOTER //
// ./src/views/Components/MacroMaps/Partials/ReferenceTab.tsx